export default __webpack_public_path__ + "static/media/back.ebd825c5.svg";